import { getImageBucketFileIdsFromNoteContents } from './getImageBucketFileIdsFromNoteContents.mjs'

export function getAllNoteBucketFileIds(note) {
  if (!note || !note.yDoc) return new Set()
  const fileIds = new Set()

  for (const fileId of note.fileIds) {
    fileIds.add(fileId)
  }

  const imageFileIds = getImageBucketFileIdsFromNoteContents(note)
  for (const fileId of imageFileIds) {
    fileIds.add(fileId)
  }
  return fileIds
}
